import type { ExtractPropTypes } from 'vue'

export const fixProps = {
	// 初始离左侧距离
	left: { type: [String, Number], default: 'auto' },
	// 初始离右侧距离，left 为 'auto' 时有效
	right: { type: [String, Number], default: 1 },
	// 初始离顶部距离
	top: { type: [String, Number], default: 'auto' },
	// 初始离底部距离，top 为 'auto' 时有效
	bottom: { type: [String, Number], default: 1 },
	number: { type: [String, Number], default: 0 },
	appendToBody: { type: Boolean, default: true },
	draggable: Boolean
}

export type FixProps = ExtractPropTypes<typeof fixProps>

export const fixEmits = ['click']

export type FixEmits = typeof fixEmits
